export default __webpack_public_path__ + "static/media/006-oceanic.e800e205.png";